import {get, includes, isString} from 'lodash';

import EnableFaceID from '/component/partial/EnableFaceID/EnableFaceID';
import {LOGIN_TYPE} from '/enum/biometrics.enum';
import {BAD_REQUEST, NO_NETWORK_EXCEPTION} from '/enum/errors.enum';
import {EVENT_NAMES, LOGIN_ERROR_STATE, LOGIN_STATUS} from '/enum/tealium.enum';
import {withTranslation} from '/provider/TranslationProvider';
import {showAlert} from '/util/alert.util';
import {getBiometricsUtilDefaultInstance} from '/util/biometrics/biometrics.util';
import {generateCallback} from '/util/component.util';
import {getTealiumUtilDefaultInstance} from '/util/tealium';

export function handleError({
  error,
  sendEvent,
  setError,
  email,
  login_enable,
  lastPaidRank,
}: any) {
  const errorMessage = setErrorMessage({error, setError});
  sendEvent({
    login_enable: login_enable,
    eventName: EVENT_NAMES.loginClick,
    success: LOGIN_STATUS.fail,
    error_state: LOGIN_ERROR_STATE.true,
    email: email,
    lastPaidRank: lastPaidRank,
  });

  return errorMessage;
}

export function handleUnknownErrorMessage({setError}: any) {
  const errorMessage = withTranslation.ts(
    'login.errorUnknown',
    'We apologize you are unable to log in to OPTAVIAConnect.com.For assistance, please contact our Coach Support Team directly at 1.888.OPTAVIA(1.888.678.2842).We appreciate your patience',
  );
  setError(errorMessage);
  return errorMessage;
}

export function handleBadRequestError({error, setError}: any) {
  const body = get(error, 'meta.body');
  const errorBody = isString(body) ? JSON.parse(body) : null;
  const errorDescription = get(errorBody, 'error_description', '');

  if (includes(errorDescription, 'The credentials provided were invalid')) {
    const errorMessage = withTranslation.ts(
      'login.errorCredentials',
      'Your username and / or password was incorrect',
    );
    setError(errorMessage);
    const sendEvent = getTealiumUtilDefaultInstance().generateTrackEvent({
      eventName: EVENT_NAMES.loginError,
    });
    sendEvent({
      eventName: EVENT_NAMES.loginError,
      success: LOGIN_STATUS.fail,
      error_message: 'incorrect credentials',
    });
    return errorMessage;
  } else {
    return handleUnknownErrorMessage({setError});
  }
}

export function setErrorMessage({error, setError}: any) {
  // Handle Error objects thrown from request.ts
  let parsedError = error;
  if (error instanceof Error) {
    try {
      parsedError = JSON.parse(error.message);
    } catch (parseError) {
      // If parsing fails, use the original error
      parsedError = error;
    }
  }

  switch (parsedError.code) {
    case BAD_REQUEST:
      return handleBadRequestError({error: parsedError, setError, showAlert});
    case NO_NETWORK_EXCEPTION:
      const errorMessage = withTranslation.ts(
        'login.noNetwork',
        'Login failed. Check your internet connection',
      );
      setError(errorMessage);
      return errorMessage;
    default:
      return handleUnknownErrorMessage({setError});
  }
}

export const handleBiometricAuth =
  ({promptMessage, setValue}: any) =>
  () => {
    return getBiometricsUtilDefaultInstance()
      .retrievePassword({
        setValue,
        promptMessage,
        loginType: LOGIN_TYPE.biometrics,
      })()
      .then((res: any) => {
        return res;
      })
      .catch((err: any) => {
        return err;
      });
  };

export const handleBiometricsModalPopup = ({
  firstLoginValue,
  biometricType,
  showPopup,
  hidePopup,
  setBiometricsOptInValue,
  setUpFaceIDval,
  handleOnSubmit,
  setBiometricsOptIn,
  login,
  password,
  setValue,
  buttonData,
  biometricsOptIn,
}: any) => {
  if (setUpFaceIDval) {
    showPopup(
      EnableFaceID,
      {
        onClose: generateCallback({func: hidePopup}),
        biometricType: biometricType,
        setBiometricsOptInValue: setBiometricsOptInValue,
        hidePopup: hidePopup,
        showPopup: showPopup,
        handleOnSubmit: handleOnSubmit,
        firstLoginValue: firstLoginValue,
        setBiometricsOptIn: setBiometricsOptIn,
        login: login,
        password: password,
        setValue: setValue,
        buttonData: buttonData,
        biometricsOptIn: biometricsOptIn,
        setUpFaceIDval: setUpFaceIDval,
      },
      {avoidable: false, showFullModal: true},
    );
  }
};
